


















import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import axios, { resHandle, axiosM } from "@/plugins/axios.ts";
import { validatePhone } from "@/plugins/elValidateRules.ts";
@Component({})
export default class RegisterView extends Vue {
  private forgot: any = {};
  private rules: any = {
    用户名: [{ required: true, message: "用户名必须填写", trigger: "blur" }]
  };
  /**
   * @description 前往登录
   */
  private goToLogin() {
    this.$router.push("/access/login");
  }
}
